import { Layout, Text, Tag } from '@loadsmart/loadsmart-ui'

import { type PriceItemType } from 'core/accounting/domain/PriceItemType'
import { isEmpty } from 'core/utils/array'

import { useConfigContext } from 'config/ui/ConfigContext'

import type { QuoteAccessorial } from '../domain/QuoteAccessorial'

export type QuoteAccessorialsProps = {
  accessorials?: Array<QuoteAccessorial>
  requestedAccessorials: Array<PriceItemType>
}

function QuoteAccessorialsTags({ accessorials, requestedAccessorials }: QuoteAccessorialsProps) {
  const config = useConfigContext()
  const enablePriceItemTypes = config.enablePriceItemTypes.toBoolean()
  const accessorialsAreEmpty = enablePriceItemTypes
    ? isEmpty(requestedAccessorials)
    : isEmpty(accessorials)

  if (accessorialsAreEmpty) {
    return (
      <Tag size="small" variant="default">
        No charges requested
      </Tag>
    )
  }

  if (enablePriceItemTypes) {
    return (
      <>
        {requestedAccessorials.map(accessorial => (
          <Tag key={accessorial.uuid} size="small" variant="warning">
            {accessorial.label}
          </Tag>
        ))}
      </>
    )
  }

  return (
    <>
      {accessorials!.map(accessorial => (
        <Tag key={accessorial.code} size="small" variant="warning">
          {accessorial.name}
        </Tag>
      ))}
    </>
  )
}

export function QuoteAccessorials({ accessorials, requestedAccessorials }: QuoteAccessorialsProps) {
  return (
    <Layout.Stack space="xs">
      <Text variant="heading-sm-bold">Accessorial charges</Text>
      <Layout.Group space="xs">
        <QuoteAccessorialsTags
          accessorials={accessorials}
          requestedAccessorials={requestedAccessorials}
        />
      </Layout.Group>
    </Layout.Stack>
  )
}
